/********************************************************************
 * Copyright (c) Certus Software, 2021.                             *
 *                                                                  *
 * This unpublished material is proprietary to Certus Software.     *
 * All rights reserved. The methods and techniques described        *
 * herein are considered confidential and/or trade secrets.         *
 * Reproduction or distribution, in whole or in part, is forbidden  *
 * except by express written permission of Certus Software.         *
 ********************************************************************/

import {Component, Input, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {Router} from '@angular/router';
import {UserService} from '../../_services/user.service';
import {Observable, Subscription} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {AuthService} from '../../_services/auth.service';
import {NgcCookieConsentService} from 'ngx-cookieconsent';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {CookieDetailsComponent} from '../cookie-details/cookie-details.component';
import {MatSidenav} from '@angular/material/sidenav';
import {UserType} from '../../_models/user';

@Component({
  selector: 'app-appbar',
  templateUrl: './appbar.component.html',
  styleUrls: ['./appbar.component.scss']
})
export class AppbarComponent implements OnInit, OnDestroy {

  @Input() appDrawer: MatSidenav;
  private initializeSubscription: Subscription;

  user: any;
  isLoggedIn: Observable<boolean>;
  enteredButton = false;
  isMatMenuOpen = false;
  prevButtonTrigger;

  public get UserType(): typeof UserType {
    return UserType;
  }

  constructor(
    public router: Router,
    private userService: UserService,
    public translate: TranslateService,
    private authService: AuthService,
    private ccService: NgcCookieConsentService,
    public dialog: MatDialog,
    private ren: Renderer2
  ) { }

  ngOnInit(): void {
    this.initializeSubscription = new Subscription();
    this.isLoggedIn = this.userService.isAuthenticated;
    this.userService.currentUser.subscribe(data => {
      this.user = this.userService.getCurrentUser();
    });
  }

  logout() {
    this.userService.purgeAuth();
    this.router.navigate(['/login']);
  }

  /* LANGUAGE CHANGE - CONFIGURE TRANSLATION HERE */
  changeAppLanguage () {
    let lang = '';
    if (this.translate.currentLang === 'hu') {
      lang = 'en';
      this.translate.use(lang);
    } else {
      lang = 'hu';
      this.translate.use(lang);
    }
    if (this.ccService.isOpen()) {
      this.changeCookiePopupLanguage();
    }
    this.authService.saveAppLanguage(lang);
    document.documentElement.lang = lang;
  }

  changeCookiePopupLanguage() {
    const that = this;
    this.translate
      .get(['app.cookie.message', 'app.cookie.dismiss',
        'app.cookie.learnMore', 'app.cookie.cookieConsent',
        'home.resources.privacyPolicyUrl'])
      .subscribe(data => {
        this.initializeSubscription = this.ccService.popupOpen$.subscribe(
          () => {
            document.getElementsByClassName('cc-window')[0]
              .setAttribute('aria-label', data['app.cookie.cookieConsent']);
            (document.getElementsByClassName('cc-link')[0] as HTMLElement).onclick = function () {
              return that.dialog.open(CookieDetailsComponent, {
                maxWidth: '100%',
                width: '100%'
              });
            };
          });
        this.ccService.getConfig().content = this.ccService.getConfig().content || {} ;
        // Override default messages with the translated ones
        this.ccService.getConfig().content.message = data['app.cookie.message'];
        this.ccService.getConfig().content.dismiss = data['app.cookie.dismiss'];
        this.ccService.getConfig().content.privacyPolicyLabel = data['app.cookie.learnMore'];
        // this.ccService.getConfig().content.privacyPolicyHref = data['home.resources.privacyPolicyUrl'];
        this.ccService.destroy(); // remove previous cookie bar (with default messages)
        this.ccService.init(this.ccService.getConfig()); // update config with translated messages
      });
  }

 /* menuenter() {
    this.isMatMenuOpen = true;
  }

  menuLeave(trigger, button) {
    setTimeout(() => {
      if (!this.enteredButton) {
        this.isMatMenuOpen = false;
        trigger.closeMenu();
        // this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-focused');
        // this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-program-focused');
        button.blur();
      } else {
        this.isMatMenuOpen = false;
      }
    }, 80);
  }

  buttonEnter(trigger) {
    setTimeout(() => {
      if (this.prevButtonTrigger && this.prevButtonTrigger !== trigger) {
        this.prevButtonTrigger.closeMenu();
        this.prevButtonTrigger = trigger;
        this.isMatMenuOpen = false;
        trigger.openMenu();
        // this.ren.removeClass(trigger.menu.items.first['_elementRef'].nativeElement, 'cdk-focused');
        // this.ren.removeClass(trigger.menu.items.first['_elementRef'].nativeElement, 'cdk-program-focused');
      } else if (!this.isMatMenuOpen) {
        this.enteredButton = true;
        this.prevButtonTrigger = trigger;
        trigger.openMenu();
        // this.ren.removeClass(trigger.menu.items.first['_elementRef'].nativeElement, 'cdk-focused');
        // this.ren.removeClass(trigger.menu.items.first['_elementRef'].nativeElement, 'cdk-program-focused');
      } else {
        this.enteredButton = true;
        this.prevButtonTrigger = trigger;
      }
    });
  }

  buttonLeave(trigger, button) {
    setTimeout(() => {
      if (this.enteredButton && !this.isMatMenuOpen) {
        trigger.closeMenu();
        // this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-focused');
        // this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-program-focused');
        button.blur();
      } if (!this.isMatMenuOpen) {
        trigger.closeMenu();
        // this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-focused');
        // this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-program-focused');
        button.blur();
      } else {
        this.enteredButton = false;
      }
    }, 100);
  }*/

  ngOnDestroy() {
    this.initializeSubscription.unsubscribe();
  }
}
